import RecordsPage from "../records/RecordsPage";
export default function Page() {
  return <RecordsPage featureKey="visits" />;
}
